export enum TagContainer {
  Media = '1',
  Analytics = '7',
  ABtests = '12'
}
